export default "__VITE_ASSET__Cg6MiqG___"